/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppTemplateUnarchive } from '../../axios/whatsAppTemplateUnarchive'
import type {
	WhatsAppTemplateUnarchiveError,
	WhatsAppTemplateUnarchivePathParams,
	WhatsAppTemplateUnarchiveResponse,
} from '../../types/WhatsAppTemplateUnarchive'

export const whatsAppTemplateUnarchiveMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-templates/:templateId/unarchive' }] as const

export type WhatsAppTemplateUnarchiveMutationKey = ReturnType<typeof whatsAppTemplateUnarchiveMutationKey>

export type WhatsAppTemplateUnarchiveVariables = {
	organisationId: WhatsAppTemplateUnarchivePathParams['organisationId']
	templateId: WhatsAppTemplateUnarchivePathParams['templateId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::unarchive */
export function useWhatsAppTemplateUnarchive<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppTemplateUnarchiveResponse,
		AxiosError<WhatsAppTemplateUnarchiveError>,
		WhatsAppTemplateUnarchiveVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppTemplateUnarchiveMutationKey(),
		mutationFn: ({ organisationId, templateId }: WhatsAppTemplateUnarchiveVariables) =>
			whatsAppTemplateUnarchive(organisationId, templateId, config).then(res => res.data),
		...options,
	})
}
